export class LetterResult {
    authIntakeNotificationId!: number;
    letterGuid!: string;
}